






import {Component, Vue} from 'vue-property-decorator';

import SessionEdit from "@share/session-edit/SessionEdit.vue";

@Component({
    components: { SessionEdit }
})
export default class SessionEditView extends Vue {

}
